import {importAll} from '../../../utils/functions';

export default () => importAll(require.context('../../../images/canari', false, /\.(png|jpe?g|svg)$/));